import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=2f652dd8&scoped=true&"
import script from "./Tags.vue?vue&type=script&lang=ts&"
export * from "./Tags.vue?vue&type=script&lang=ts&"
import style0 from "./Tags.vue?vue&type=style&index=0&id=2f652dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f652dd8",
  null
  
)

export default component.exports